import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';

// Angular modules
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

// Interceptors
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuditInterceptor } from './auth/interceptors/audit.interceptor';
import { TokenInterceptor } from './auth/interceptors/token.interceptor';
import { CaptchaInterceptor } from './shared/interceptors/captcha.interceptor';

// LOCAL
import localeEsAr from '@angular/common/locales/es-AR';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEsAr, 'es-AR');

// Modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

// PrimeNG
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';

// Spinner
import { NgxSpinnerModule } from 'ngx-spinner';

// Services
import { MessageService } from 'primeng/api';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    HttpClientModule,
    RippleModule,
    SharedModule,
    ToastModule,
    RecaptchaV3Module,
    NgxSpinnerModule,
  ],
  providers: [
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaptchaInterceptor,
      multi: true,
    },
    /*   {
      provide: HTTP_INTERCEPTORS,
      useClass: AuditInterceptor,
      multi: true,
    },*/
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'ARS' },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
